import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./changePassword.css";

const ChangePassword = ({ isLoggedIn, loginUser, onLogout }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isLoggedIn) {
    navigate("/");
    return;
  }

  if (loginUser.googleId) {
    navigate("/profile");
    return;
  }

  const handleChange = (e) => {
    setError("");
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.currentPassword) {
      setError("Please enter your current password");
      return;
    }
    const strongPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!strongPassword.test(formData.newPassword)) {
      setError("Password must be at least 8 characters with one uppercase, one lowercase, and one number");
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`/api/v1/user/${loginUser._id}/change-password`, formData);
      navigate("/profile");
      window.location.reload();
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sr-chgpw">
      <div className="sr-chgpw__top">
        <div className="sr-chgpw__top-content">
          <h1 className="sr-chgpw__title">Change Password</h1>
        </div>
      </div>
      <div className="sr-chgpw__body">
        <form className="sr-chgpw__form" onSubmit={handleSubmit}>
          <div className="sr-chgpw__group">
            <label className="sr-chgpw__label" htmlFor="currentPassword">Current Password</label>
            <input
              className="sr-chgpw__input"
              type="password"
              id="currentPassword"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              placeholder="Enter current password"
              autoComplete="current-password"
            />
          </div>

          <div className="sr-chgpw__group">
            <label className="sr-chgpw__label" htmlFor="newPassword">New Password</label>
            <input
              className="sr-chgpw__input"
              type="password"
              id="newPassword"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              placeholder="Min 8 characters"
              autoComplete="new-password"
            />
          </div>

          <div className="sr-chgpw__group">
            <label className="sr-chgpw__label" htmlFor="confirmPassword">Confirm New Password</label>
            <input
              className="sr-chgpw__input"
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Re-enter new password"
              autoComplete="new-password"
            />
          </div>

          {error && <p className="sr-chgpw__error">{error}</p>}

          <div className="sr-chgpw__actions">
            <button className="sr-chgpw__btn sr-chgpw__btn--secondary" type="button" onClick={() => navigate("/profile")}>
              Cancel
            </button>
            <button className="sr-chgpw__btn sr-chgpw__btn--primary" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
